<template>


  <div class="hello">
    <h1>{{ msg }}</h1>
    
<div class="div_box">
    <p>
      You need to connect with the wallet that is configured in the Android Game in order to claim your coins.
    </p>
    <br>

    <p>
    <input size="100"  placeholder="User Address" type="text" name="userAddress" class="form__input" v-model="userAddress" readonly/>
    </p>
    
    <p>
      <label for="name" class="form__label">$ERFC Balance</label>
    </p>

    <p>
      <br>
    <input size="100"  placeholder="$ERFC balance" type="text" name="erfcBalance" class="form__input_text_big" v-model="erfcBalance" readonly/>
    </p>

    <p><br>
    <button class="button-36" @click="getTokenBalance">
      Refresh
    </button>
  </p>
  </div>
  </div>
</template>

<script>
import { ethers } from "ethers";
//import $ from 'jquery';

export default {
  name: 'UserWallet',
  props: {
    msg: String
  }, data() {
      return {
        userAddress: '',
        erfcBalance: ''

      }
    },methods: {
           
         getBalance(_address){
          console.log("Received: "+ _address) 
          _address = _address +""
          var address = ethers.utils.getAddress(_address)
          window.ethereum.request({
            method:'eth_getBalance', 
            params: [address, 'latest']
          }).then(balance => {
            // Return string value to convert it into int balance
            console.log(balance) 
              
            // Yarn add ethers for using ethers utils or
            // npm install ethers
            //console.log(window.ethereum.utils.formatEther(balance))
            console.log("Amount Ether: " + ethers.utils.formatEther(balance))

            //contracts(address)
            // Format the string into main latest balance
          })
        }, getTokenBalance(){
              const ethers = require('ethers')

              
              // The Contract interface
              let abi = [
                "function totalSupply() external view returns (uint256)",
                "function balanceOf(address account) external view returns (uint256)",
                "function allowance(address owner, address spender) external view returns (uint256)",
                "function transfer(address recipient, uint256 amount) external returns (bool)",
                "function approve(address spender, uint256 amount) external returns (bool)",
                "function transferFrom(address sender, address recipient, uint256 amount) external returns (bool)",
                "event Transfer(address indexed from, address indexed to, uint256 value)",
                "event Approval(address indexed owner, address indexed spender, uint256 value)"
              ]

              // Connect to the network
              //let provider = ethers.getDefaultProvider()
              //let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc_testnet_chapel") // testnet
              let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc") // production

              // The address from the above deployment example
              let contractAddress = "0xBe055654011E1FD1CC141F96Bb2edAe4930dCa28" // production
              //let contractAddress = "0xC3672F25C5dA3ac3E752d0A9804BA7495A99Deba" // testnet

              // We connect to the Contract using a Provider, so we will only
              // have read-only access to the Contract
              let contract = new ethers.Contract(contractAddress, abi, provider)

         /*
              console.log(contract)
              // Get the current value
              contract.totalSupply().then(totalSupply => {
                // Return string value to convert it into int balance
                console.log("Supply: "+ethers.utils.formatEther(totalSupply)) 
                this.erfcBalance = ethers.utils.formatEther(totalSupply)
                
            }) */
                
            
            contract.balanceOf(""+this.userAddress).then(balance => {
                  // Return string value to convert it into int balance
             //     console.log("$ERFC balance: " + ethers.utils.formatEther(balance)) ;
                  this.erfcBalance = ethers.utils.formatEther(balance);
                  
                })

          }
            },beforeMount() {

                  if(window.ethereum){
                  // Do something 
                  //alert("Metamask extension OK!!")
                  }else{
                    alert("install metamask extension!!")
                  }

                  window.ethereum.request({method:'eth_requestAccounts'})
                .then(res=>{
                        // Return the address of the wallet
                        console.log("Address:" + res) ;
                        this.userAddress = res;
                       // this.getBalance(res);
                        this.getTokenBalance();
                
                })
            }
           
        

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}


.form__label {
  font-family: 'Roboto', sans-serif;
  font-size: 1.2rem;
  margin-left: 2rem;
  margin-top: 0.7rem;
  display: block;
  transition: all 0.3s;
  transform: translateY(0rem);
}

.form__input {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 0.60rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 50%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}


.form__input_text_big {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 50%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}

.form__input:placeholder-shown + .form__label {
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translateY(-4rem);
  transform: translateY(-4rem);
}

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  font-size: 62,5%;
}


.div_box {
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  border: 0.05rem;
  width: 40%;
  display: block;
  
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
}



.button-36 {
  background-image: linear-gradient(92.88deg, #455EB5 9.16%, #5643CC 43.89%, #673FD7 64.72%);
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  flex-shrink: 0;
  font-family: "Inter UI","SF Pro Display",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Open Sans","Helvetica Neue",sans-serif;
  font-size: 16px;
  font-weight: 500;
  height: 4rem;
  padding: 0 1.6rem;
  text-align: center;
  text-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px;
  transition: all .5s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-36:hover {
  box-shadow: rgba(80, 63, 205, 0.5) 0 1px 30px;
  transition-duration: .1s;
}

@media (min-width: 768px) {
  .button-36 {
    padding: 0 2.6rem;
  }
}

</style>
